// styles
import {
  chartDashboardBoxStyle,
  chartDashboardTableWrapperStyle,
  chartDashboardType01Style
} from 'styles';

// libraries
import styled from 'styled-components';

export const StyledTodayWorkStatus = styled.div`
  ${chartDashboardBoxStyle}
  ${chartDashboardType01Style}
  ${chartDashboardTableWrapperStyle}
`;
